import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="faq" data-id="element-77" data-mp="1bmlo9c6xq5ml">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-78" data-mp="1gk5aozdsdopm">
        <h2 id="faq" className="font-display text-3xl font-900 leading-tight text-white sm:text-4xl" data-id="element-79" data-mp="248o8um34gl3z">
          Lo que más nos preguntan
        </h2>

        <ul className="mt-10 divide-y divide-ink-800 border-y border-ink-800" data-id="element-80" data-mp="289zy2qi334bn">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-81" data-mp="1zgwpavidvfnc" data-mpi={index}>
                <h3 data-id="element-82" data-mp="2n8255aobq7xn">
                  <button onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-150 ease-smooth hover:text-gold" data-id="element-83" data-mp="2n7ilnpj0zbhi">
                    <span className="font-display text-base font-700 text-white sm:text-lg" data-id="element-84" data-mp="10rvriuxo9uj4">
                      {faq.question}
                    </span>
                    <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full border border-ink-600 text-gold" data-id="element-85" data-mp="19tliy0rk0tgw">
                      {isOpen ? <MinusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-86" data-mp="1jkzp2re0grj0" /> : <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-87" data-mp="1xiwodvjunc1d" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-88" data-mp="35onpn97067t">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-89" data-mp="3uc9auvw4mtzk">
                      <p className="pb-6 pr-10 text-[15px] leading-relaxed text-slate-300" data-id="element-90" data-mp="2c8megdcwon7c">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}